export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg">
                七
              </span>
              <span className="font-heading text-xl text-background-50 font-semibold">七七影院</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              七七影院是国内领先的免费高清影视在线观看平台。提供高清免费电影、免费电视剧在线看服务，画质超清不缓冲，无需付费即点即看，涵盖热播剧与经典电影大全。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">首页</a>
              <a href="#features" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">观影优势</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">精选专题</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">常见问题</a>
              <a href="#contact" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">联系我们</a>
            </nav>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">影视分类</h3>
            <nav className="flex flex-col gap-2">
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">动作大片</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">喜剧电影</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">悬疑惊悚</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">动漫动画</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-300 transition-colors no-underline cursor-pointer">纪录片</a>
            </nav>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              感谢以下合作伙伴对七七影院的支持与信任。我们期待与更多优秀平台携手，为广大影迷提供更丰富的观影选择。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020-2026 七七影院 qiqicinema.com 版权所有 | 高清免费电影在线看 · 免费电视剧在线看全集不缓冲
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-300 transition-colors no-underline cursor-pointer">服务条款</a>
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-300 transition-colors no-underline cursor-pointer">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}